import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import SvgIcon from 'vue-svgicon'
import VueSocialSharing  from 'vue-social-sharing'
import StoryblokVue from 'storyblok-vue'
import './assets/css/tailwind.css'
import '@/assets/icons'
import './registerServiceWorker'

Vue.use(StoryblokVue)
Vue.use(SvgIcon, {
  tagName: 'icon',
  isOriginalDefault: true
})
Vue.use(VueSocialSharing)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
